import { EDPData } from "../../../models/loanApp/edpData";

export const getPropertiesFullSet: EDPData = {
  properties: [
    {
      guid: "c63f3ace-1353-4402-83d0-4e8192cd25e4",
      bfeNumber: 8923139829,
      address: "Sydvestvej, 12, A, 7100, Vejle",
    },
    {
      guid: "55e06970-5e10-437f-ac04-c6122b0aff8b",
      bfeNumber: 100000019,
      address: "Sydvestvej, 118, A, 2700, Kruså",
    },
    {
      guid: "75482a3a-202d-4115-a925-dafbebaf6b36",
      bfeNumber: 100000020,
      address: "Sydvestvej, 119, A, 2700, Kruså",
    },
    {
      guid: "a2f92482-9eb7-4ca8-8ff7-aedf66cc9fe6",
      bfeNumber: 100000021,
      address: "Sydvestvej, 120, A, 2700, Kruså",
    },
  ],
};
